import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import Subtitle from "./Subtitle";
import AnimtionLeftPanelBlue from "src/Component/AnimtionLeftPanelBlue";
import ChatMessageAnimation from "../../Component/ChatMessageAnimation";

// Constants
const PAGE_ID = 4;
const BG_ID = 4;
const BG_TYPE = "jpg";
const NEXT_PAGE_ID = PAGE_ID + 1;
const BACK_PAGE_ID = PAGE_ID - 1;

const LEFT_TITLE = "Customer requests for\nFiber & Voice connection";

// Main data function that returns the template data
const DATA = (): DataMainTemplate => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const backButton =
    BACK_PAGE_ID > 0
      ? {
          label: "Back",
          type: "back" as const,
          startIcon: { icon: "arrow-right", color: "#fff" },
          onClick: () => setCurrentPage(BACK_PAGE_ID),
          style: {
            borderRadius: "45px",
            padding: "var(--width-5) var(--width-25)",
            gap: "var(--width-16)",
          },
        }
      : undefined;

  const nextButton = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NEXT_PAGE_ID),
    style: {
      borderRadius: "45px",
      padding: "var(--width-5) var(--width-25)",
      gap: "var(--width-16)",
    },
  };

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (PAGE_ID === currentPage) {
      if (videoRef.current) videoRef.current.play();

      timer = setTimeout(() => {
        setStartAnimation(true);
      }, 100);
    } else {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }

      setStartAnimation(false);
    }

    return () => clearTimeout(timer);
  }, [currentPage]);

  const leftBeforeTitle = (
    <p
      style={{
        marginBottom: "var(--width-8)",
        color: "#D1EEFF",
        fontFamily: "Myriad Pro",
        fontSize: "var(--width-24)",
        fontStyle: "normal",
        fontWeight: "300",
        lineHeight: "110%",
        transform: "translateY(0%)",
      }}
    >
      Scenario Introduction
    </p>
  );

  return {
    styleBody: { marginTop: 0 },
    bgImage: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
    leftBeforeTitle: leftBeforeTitle,
    title: LEFT_TITLE,
    leftAfterTitle: <Subtitle text={"Solutions highlights"} />,
    description:
      '<ul id="ilo-ul-screen-4"><li>Seamless Experience</li><li>Agentic AI for Automation</li><li>Copilot for Operations</li><li>Proactive Nudges</li></ul>',
    leftAfterDescription: (
      <AnimtionLeftPanelBlue
        style={{
          left: "calc(-1 * var(--width-0))",
          width: "var(--width-792)",
          top: "var(--height-20)",
        }}
        startAnimation={startAnimation}
        image={`${Config.BASE_URL}/images/screen_${PAGE_ID}/left_0.png`}
      />
    ),
    rightSideComponent: (
      <ChatMessageAnimation
        startAnimation={startAnimation}
        baseImagePath={`${Config.BASE_URL}/images/screen_${PAGE_ID}/right_`}
        containerStyle={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
        }}
        chatWidth="var(--width-600)" // Width of the chat container
        verticalSpacing="2%" // Less space between messages
        maxWidth="var(--width-500)" // Maximum width of each message
        scaleArray={[1, 0.8]}
        pulseConfig={{
          enabled: true,
          duration: 2, // 2 seconds per cycle
          size: 7, // 15px glow spread
          color: "#0DBC7C",
        }}
        transformPositionX="45%"
        transformPositionY="-60%"
      />
    ),
    next: nextButton,
    back: backButton,
  };
};

export default DATA;
